import React from 'react';
import { useSelector } from 'react-redux';
import {
    ESTADO_CANCELACION_SOLICITADA,
    desenlaceCobro,
} from '../../../helpers/cobroDatafono';

/**
 * EX-595: modal bloqueante mientras el datáfono resuelve el cobro.
 *
 * Es presentacional: no consulta al backend ni decide nada. El polling vive en
 * `startCobroDatafonoYEsperar` y aquí solo se pinta el estado que va llegando.
 *
 * No se puede cerrar mientras el cobro está en curso: mientras la orden vive en el terminal el
 * pago todavía puede completarse, y cerrar a ciegas dejaría al operario sin saber si cobró.
 */
export const ModalEsperaDatafono = ({
    abierto,
    estado,
    importe,
    desenlace = null,
    onCancelar,
    onCerrar,
}) => {
    const { colores } = useSelector(state => state.ui);

    if (!abierto) return null;

    const cancelacionSolicitada = estado === ESTADO_CANCELACION_SOLICITADA;
    const desenlaceMostrado = desenlace ? desenlaceCobro(desenlace.estado, desenlace.detalleError) : null;
    // El backend devuelve el importe en euros, no en céntimos, así que no pasa por
    // `formatCurrency` (que espera céntimos). El separador decimal es la coma: es el importe que
    // el operario contrasta con el que muestra el terminal.
    const importeNumerico = Number(importe);
    const importeTexto = Number.isFinite(importeNumerico)
        ? `${importeNumerico.toFixed(2).replace('.', ',')} €`
        : '';

    return (
        <div className="modal-ylm active modal-datafono">
            <div className="modal-bg"></div>
            <div className="modal-wrapper">
                <div className="modal-title">
                    <h3 style={{ color: colores.colorPrincipal }}>
                        {desenlaceMostrado ? desenlaceMostrado.titulo : 'Cobro en el datáfono'}
                    </h3>
                </div>

                <div className="modal-body">
                    {importeTexto && <p className="modal-datafono__importe">{importeTexto}</p>}

                    {desenlaceMostrado ? (
                        <p className={`modal-datafono__mensaje modal-datafono__mensaje--${desenlaceMostrado.tono}`}>
                            {desenlaceMostrado.texto}
                        </p>
                    ) : (
                        <>
                            <span className="modal-datafono__spinner" aria-hidden="true" />
                            <p className="modal-datafono__mensaje">
                                {cancelacionSolicitada
                                    ? 'Pulsa Cancelar en el datáfono para cancelar el cobro.'
                                    : 'Sigue las instrucciones en el datáfono.'}
                            </p>
                            {cancelacionSolicitada && (
                                <p className="modal-datafono__nota">
                                    Seguimos escuchando: si el pago llega a completarse, no se perderá.
                                </p>
                            )}
                        </>
                    )}
                </div>

                <div className="modal-footer">
                    <div className="buttons">
                        {desenlaceMostrado ? (
                            <div
                                className="btn btn-confirm"
                                style={{ backgroundColor: colores.colorPrincipal }}
                                onClick={onCerrar}
                            >Entendido</div>
                        ) : (
                            <div
                                className={`btn btn-cancel ${cancelacionSolicitada ? 'btn--deshabilitado' : ''}`}
                                style={{ backgroundColor: '#F2F2F2', color: '#393D40' }}
                                onClick={cancelacionSolicitada ? undefined : onCancelar}
                            >Cancelar</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
